var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.81 22.934l-20.955 31.61-12.972-9.853 4.234-5.574 7.028 5.338 16.83-25.389 5.834 3.868z",
    fill: "#172B29"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjM1IiBjeT0iMzUiIHI9IjM1IiBmaWxsPSJ3aGl0ZSIvPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Mi44MDk0IDIyLjkzMzhMMzEuODU1IDU0LjU0NDdMMTguODgyOCA0NC42OTA5TDIzLjExNyAzOS4xMTY4TDMwLjE0NDkgNDQuNDU1Mkw0Ni45NzQ5IDE5LjA2NjJMNTIuODA5NCAyMi45MzM4WiIgZmlsbD0iIzE3MkIyOSIvPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };